import { getFooterLinks } from './getFooterLinks';
import { FooterBottom } from './FooterBottom';
import { useTranslation } from 'react-i18next';
import { useMedia } from '../../../hooks/useMediaQuery';
import { Link } from 'react-router-dom';
import { routesPath } from '../../constants/routesPath';

export function ReportFooter() {
    const { t } = useTranslation(['reportFooter']);
    const { isSmallDevice, isExtraSmallDevice } = useMedia();

    const { brand, poweredBy, sections, bottom } = getFooterLinks(t);

    const isCompact = isSmallDevice || isExtraSmallDevice;

    return (
        <footer className="print-hide" style={{ backgroundColor: '#fff', color: '#111', borderTop: '1px solid #e5e7eb' }}>
            <div style={{ maxWidth: 1280, margin: '0 auto', padding: isCompact ? '32px 16px' : '48px 24px' }}>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: isExtraSmallDevice
                            ? '1fr'
                            : isSmallDevice
                              ? 'repeat(2, 1fr)'
                              : 'repeat(5, 1fr)',
                        gap: isCompact ? 24 : 32,
                    }}
                >
                    {/* Brand Column */}
                    <div
                        style={{
                            gridColumn: isExtraSmallDevice ? '1' : isSmallDevice ? 'span 2' : 'span 2',
                            marginBottom: isCompact ? 8 : 0,
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
                            <Link to={routesPath.ROOT.DASHBOARD}>
                                <img
                                    src={brand.logo.src || 'Logo.svg'}
                                    alt={brand.logo.alt}
                                    width={brand.logo.width}
                                    height={brand.logo.height}
                                />
                            </Link>
                        </div>

                        <p style={{ color: '#4b5563', fontSize: 14, lineHeight: 1.6, marginBottom: 24 }}>
                            {brand.description}
                        </p>

                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ color: '#4b5563', fontSize: 14 }}>{poweredBy.text}</span>
                            <Link
                                to={poweredBy.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    backgroundColor: '#111827',
                                    padding: '8px 16px',
                                    borderRadius: 9999,
                                    textDecoration: 'none',
                                }}
                            >
                                <span style={{ color: '#fff', fontSize: 14, fontWeight: 500 }}>{poweredBy.name}</span>
                            </Link>
                        </div>
                    </div>

                    {/* Dynamic Sections */}
                    {sections.map((section, index) => (
                        <div key={index}>
                            <h3
                                style={{
                                    fontWeight: 600,
                                    color: '#111827',
                                    marginBottom: 16,
                                    fontSize: 14,
                                    marginTop: isCompact ? 8 : 0,
                                }}
                            >
                                {section.title}
                            </h3>
                            <ul
                                style={{
                                    listStyle: 'none',
                                    padding: 0,
                                    margin: 0,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 12,
                                }}
                            >
                                {section.links.map((link, linkIndex) => (
                                    <li key={linkIndex}>
                                        <Link
                                            to={link.href}
                                            style={{ color: '#4b5563', fontSize: 14, textDecoration: 'none' }}
                                            {...(link.external && { target: '_blank', rel: 'nofollow noopener' })}
                                        >
                                            {link.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <FooterBottom cookieStatement={bottom.cookieStatement} copyrightKey="bottom.copyright" />
            </div>
        </footer>
    );
}
